import { parseToRgb, rgb } from 'polished'

export function invertColor(color: string): string {
  const { red, green, blue } = parseToRgb(color)
  return rgb(255 - red, 255 - green, 255 - blue)
}

export function highestContrastRatio(color: string): string {
  const { red, green, blue } = parseToRgb(color)

  const luminance = 0.299 * red + 0.587 * green + 0.114 * blue

  return luminance > 128 ? '#000000' : '#FFFFFF'
}
